import { EVA_PRODUCT } from './products';

export const evaProductImage = {
  [EVA_PRODUCT.PANEL]: '/images/eva-pacs-logo.svg',
  [EVA_PRODUCT.INTELLIGENCE]: '/images/eva-pacs-logo.svg',
  [EVA_PRODUCT.MANAGEMENT]: '/images/eva-pacs-logo.svg',
  [EVA_PRODUCT.PACS]: '/images/eva-pacs-logo.svg',
};
